var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import LabelValue from '@/components/LabelValue.vue';
import Group from '@/views/Groups/Group.vue';
import { Subject } from '@/models/Subject';
import SubjectStatusCount from '@/components/curriculum/SubjectStatusCount.vue';
let DraggableGoalItem = class DraggableGoalItem extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    getGoalHasPeriod(goal) {
        if (Array.isArray(goal.period)) {
            return goal.period.length > 0;
        }
        return !!goal.period;
    }
    get selected() {
        return this.isSelected;
    }
    set selected(value) {
        this.$emit('toggle-selected', value);
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    onTriggeredSubjectStatusCountChange(newValue) {
        if (newValue) {
            const subjectStatusCount = this.$refs[`statusCount-${this.item.id}`];
            subjectStatusCount.showSubjectSummary();
        }
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], DraggableGoalItem.prototype, "group", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_b = typeof Subject !== "undefined" && Subject) === "function" ? _b : Object)
], DraggableGoalItem.prototype, "topic", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], DraggableGoalItem.prototype, "item", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], DraggableGoalItem.prototype, "hasTriggeredSubjectStatusCount", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DraggableGoalItem.prototype, "isSelected", void 0);
__decorate([
    Watch('hasTriggeredSubjectStatusCount'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DraggableGoalItem.prototype, "onTriggeredSubjectStatusCountChange", null);
DraggableGoalItem = __decorate([
    Component({
        components: {
            LabelValue,
            SubjectStatusCount,
        },
    })
], DraggableGoalItem);
export default DraggableGoalItem;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
